import React from "react";
import { useLocation } from "react-router-dom";

import LiveCasino from "../assets/images/icons/foot-menu/live-casino.svg";
import Casino from "../assets/images/icons/foot-menu/casino.svg";
import Exchange from "../assets/images/icons/foot-menu/exchange.svg";
import Sportsbook from "../assets/images/icons/foot-menu/sportsbook.svg";
import Aviator from "../assets/images/icons/foot-menu/aviator.svg";

export default function BottomNav() {
  const location = useLocation();
  const pathname = location.pathname;

  const navItems = [
    { href: "/live-casino", label: "Live Casino", icon: LiveCasino },
    { href: "/casino", label: "Virtual Casino", icon: Casino },
    { href: "/sports/Cricket", label: "Exchange", icon: Exchange },
    { href: "/sportsbook", label: "Sportsbook", icon: Sportsbook },
    { href: "/casino/spribe/aviator", label: "Aviator", icon: Aviator },
  ];

  return (
    <>
      <div className="footer-menu d-lg-none">
        <ul>
          {navItems.map((item, index) => (
            <li key={index}>
              <a
                href={item.href}
                className={pathname === item.href ? "active" : ""}
              >
                <img src={item.icon} alt={item.label} />
                <span>{item.label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
